/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import Tysiav2SearchHistory from 'DesignSystem/Svgs/Tysiav2SearchHistory/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/MedicalTab/Content/Empty",
  isSelected,
  colorActive,
  isHovered
  
}) {
let tabTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'tab',
})
let constantData = 'medical'
let aggregateData = fromAggregate.equals(tabTabValueData, constantData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected,
  colorActive,
  isHovered
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let colorActiveOrdtColorsGreen700 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7001 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7002 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7003 = colorActive ?? dtColorsGreen700
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Medical history"
 onClick={onClick}
 data="tab.tab"
 data="'medical'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 size="normal"
 color={dtColorsNeutral900}
>
{childProps => (
<Tysiav2SearchHistory
{...childProps}
  viewPath={`${viewPath}/Tysiav2SearchHistory`}
 height={12}
 width={12}
 fill2={childProps.isSelected ? colorActiveOrdtColorsGreen7003 : childProps.isHovered ? colorActiveOrdtColorsGreen7002 : dtColorsNeutral400}
/>
)}
</SubMenuTab>
{children}
</React.Fragment>)
}